import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { Calculator as CalculatorIcon } from '@one-thd/sui-icons';

const { arrayOf, node, oneOfType } = proptypes;

export const CalculatorHeader = ({ children }) => (
  <div className="sui-flex sui-flex-col">
    <div className="sui-flex sui-flex-row">
      <CalculatorIcon color="brand" />
      <span className="sui-ml-2">
        <Typography variant="body-lg" weight="bold">How much will you need?</Typography>
      </span>
    </div>
    {children}
  </div>
);

CalculatorHeader.propTypes = {
  children: oneOfType([arrayOf(node), node]),
};

CalculatorHeader.defaultProps = {
  children: null
};

CalculatorHeader.displayName = 'CalculatorHeader';